import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import StatusComp from "../../../components/StatusComp";
import CommonDatePicker from "../../../components/CommonDatePicker";
import SelectBox from "../../../components/SelectBox";
import { groupUsers, siteDetails } from "../../redux/api/dummyJson";

const CompanyUserReport = () => {
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const [selectedCompany, setSelectedCompany] = useState([]);

  const [data, setData] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);

  const location = useLocation();
  const type = location?.state?.type;

  const createdAt = moment().format("DD-MM-YYYY");

  const navigate = useNavigate();

  const handlePreview = () => {
    console.log("From:", fromDate);
    console.log("To:", toDate);
    console.log("Company:", selectedCompany);
    console.log("Site:", selectedOption);
  };

  return (
    <div className="mt-5">
      <div className={"d-flex col-md-12 ac-jb gap-5"}>
        <CommonDatePicker
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
        />

        <div className="col-md-2">
          <label className="form-label">Select Site</label>
          <SelectBox
            arrayData={siteDetails}
            data={data}
            setData={setData}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            style={true}
          />
        </div>

        <div className='"col-md-2'>
          <label className="form-label">Select Group User</label>
          <SelectBox
            arrayData={groupUsers}
            selectedOption={selectedUser}
            setSelectedOption={setSelectedUser}
            style={true}
          />
        </div>

        {/* Preview Button */}
        <div className="col-md-1 mt-4 ">
          <button
            onClick={handlePreview}
            className="submit-btn"
            disabled={
              !fromDate ||
              !toDate ||
              !selectedCompany?.label ||
              !selectedOption?.label
            }
          >
            Preview
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompanyUserReport;
